import React, { useState } from 'react';
import { Box, Fab, Backdrop } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UploadForm from './components/UploadForm';
import Timeline from './components/Timeline';

const App = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <Box sx={{ textAlign: 'center', p: 3 }}>
      <h1>Date Tracker</h1>
      <Timeline />

      {/* Backdrop when UploadForm is visible */}
      <Backdrop
        open={showForm}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}
        onClick={() => setShowForm(false)}
      >
        <Box onClick={(e) => e.stopPropagation()}>
          <UploadForm onClose={() => setShowForm(false)} />
        </Box>
      </Backdrop>

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="add"
        onClick={() => setShowForm(true)}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          width: 70,
          height: 70,
        }}
      >
        <AddIcon sx={{ fontSize: 40 }} />
      </Fab>
    </Box>
  );
};

export default App;
